import { logger } from './logger';

/**
 * Service de monitoring simple pour EKOSE
 * Version simplifiée sans dépendances externes
 */

interface MonitoringConfig {
  environment: string;
  enabled: boolean;
}

class MonitoringService {
  private static instance: MonitoringService;
  private config: MonitoringConfig;
  private isInitialized = false;

  private constructor() {
    this.config = {
      environment: import.meta.env.MODE || 'development',
      enabled: import.meta.env.MODE === 'production'
    };
  }

  static getInstance(): MonitoringService {
    if (!MonitoringService.instance) {
      MonitoringService.instance = new MonitoringService();
    }
    return MonitoringService.instance;
  }

  init(): void {
    if (this.isInitialized) return;

    if (this.config.enabled) {
      logger.debug('🔍 Monitoring: Production mode - Monitoring enabled');
    } else {
      logger.debug('🔍 Monitoring: Development mode - Console logging only');
    }

    this.isInitialized = true;
  }

  captureError(error: Error, context?: Record<string, unknown>): void {
    if (this.config.enabled) {
      // En production, ici on enverrait à un service de monitoring
      logger.error('Production Error:', error, context);
    } else {
      logger.error('Development Error:', error, context);
    }
  }

  captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info'): void {
    if (this.config.enabled) {
      logger.debug(`Production ${level}:`, message);
    } else {
      logger.debug(`Development ${level}:`, message);
    }
  }

  setUser(user: { id: string; email: string; role: string }): void {
    if (this.config.enabled) {
      logger.debug('User context set:', { id: user.id, role: user.role });
    }
  }

  clearUser(): void {
    if (this.config.enabled) {
      logger.debug('User context cleared');
    }
  }
}

// Instance singleton
const monitoring = MonitoringService.getInstance();

// Export des fonctions principales
export const initSentry = () => monitoring.init();
export const captureError = (error: Error, context?: Record<string, unknown>) => 
  monitoring.captureError(error, context);
export const captureMessage = (message: string, level?: 'info' | 'warning' | 'error') => 
  monitoring.captureMessage(message, level);
export const setUser = (user: { id: string; email: string; role: string }) => 
  monitoring.setUser(user);
export const clearUser = () => monitoring.clearUser();

// Export par défaut
export default monitoring;